<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <b-row>
            <b-col md="3">
              <b-input-group>
                <b-form-datepicker
                  v-model="search.from_date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  placeholder="Created from date"
                />
                <template v-slot:append>
                  <b-button
                    v-if="search.from_date"
                    aria-label="Clear date"
                    @click="search.from_date = ''"
                  >
                    <span>x</span>
                  </b-button>
                </template>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <b-input-group>
                <b-form-datepicker
                  v-model="search.to_date"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  placeholder="Created to date"
                />
                <template v-slot:append>
                  <b-button
                    v-if="search.to_date"
                    aria-label="Clear date"
                    @click="search.to_date = ''"
                  >
                    <span>x</span>
                  </b-button>
                </template>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <b-input-group>
                <b-form-datepicker
                  v-model="search.from_deadline"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  placeholder="Job from deadline"
                />
                <template v-slot:append>
                  <b-button
                    v-if="search.from_deadline"
                    aria-label="Clear date"
                    @click="search.from_deadline = ''"
                  >
                    <span>x</span>
                  </b-button>
                </template>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <b-input-group>
                <b-form-datepicker
                  v-model="search.to_deadline"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  placeholder="Job to deadline"
                />
                <template v-slot:append>
                  <b-button
                    v-if="search.to_deadline"
                    aria-label="Clear date"
                    @click="search.to_deadline = ''"
                  >
                    <span>x</span>
                  </b-button>
                </template>
              </b-input-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card no-body>
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <b-col
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 bg-none"
              >
                <label>Show</label>
                <!-- :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" -->
                <v-select
                  @on-change="paginateChange"
                  :options="perPageOptions"
                  v-model="search.paginate"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>
              <!-- Per Page -->
              <!-- Search -->
              <b-col md="4">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="search.search_data"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                </div>
              </b-col>
              <b-col md="3">
                <v-select
                  id="status"
                  v-model="search.status"
                  placeholder="Select Status"
                  :options="Status"
                  label="name"
                  :reduce="(option) => option.id"
                />
              </b-col>
              <b-col md="1">
                <div class="text-center">
                  <router-link to="/job/create">
                    <button
                      class="btn btn-primary btn-md"
                      style="margin-right: 5px"
                    >
                      Create
                    </button>
                  </router-link>
                </div>
              </b-col>
            </b-row>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center">Sl</th>
                  <th>Name</th>
                  <th class="text-center">Category Name</th>
                  <th>Job Status</th>
                  <th>Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody v-if="job_opportunities.job_opportunities">
                <tr
                  v-for="(job_opportunitie, index) in job_opportunities
                    .job_opportunities.data"
                  :key="index"
                >
                  <td class="align-middle text-center">
                    {{ job_opportunities.job_opportunities.from + index }}
                  </td>
                  <td class="align-middle">
                    <p class="mb-0" style="font-size: medium">
                      <b>{{ job_opportunitie.name }}</b>
                    </p>

                    <p class="mb-0">
                      <b>Deadline :</b>
                      {{ job_opportunitie.deadline | date_format }}
                    </p>
                  </td>
                  <td class="text-center">
                    {{ job_opportunitie.job_category.name }}
                  </td>

                  <td>
                    {{
                      job_opportunitie.job_status == 1
                        ? "Full Time"
                        : job_opportunitie.job_status == 2
                        ? "Part Time"
                        : "Contact"
                    }}
                  </td>
                  <td>
                    <p class="mb-0">
                      <span
                        class="badge"
                        style="margin-right: 5px"
                        :class="
                          job_opportunitie.status == 1
                            ? 'badge-success'
                            : 'badge-danger'
                        "
                      >
                        {{
                          job_opportunitie.status == 1 ? "Active" : "Inactive"
                        }}
                      </span>
                    </p>
                  </td>

                  <td class="align-middle text-center">
                    <router-link :to="'/job/edit/' + job_opportunitie.id">
                      <button
                        class="btn btn-primary btn-sm"
                        style="margin-right: 5px"
                      >
                        <feather-icon icon="EditIcon" size="16" />
                      </button>
                    </router-link>
                    <button
                      v-if="permission.delete"
                      class="btn btn-danger btn-sm"
                      @click="Delete(job_opportunitie.id)"
                    >
                      <feather-icon icon="TrashIcon" size="16" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mx-2 mb-2">
            <b-row v-if="job_opportunities.job_opportunities">
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >Showing
                  {{
                    job_opportunities.job_opportunities.from
                      ? job_opportunities.job_opportunities.from
                      : 0
                  }}
                  to
                  {{
                    job_opportunities.job_opportunities.to
                      ? job_opportunities.job_opportunities.to
                      : 0
                  }}
                  of
                  {{
                    job_opportunities.job_opportunities.total
                      ? job_opportunities.job_opportunities.total
                      : 0
                  }}
                  entries</span
                >
              </b-col>

              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <pagination
                  :data="job_opportunities.job_opportunities"
                  @pagination-change-page="getResults"
                  align="right"
                  :show-disabled="true"
                  :limit="5"
                ></pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
  BFormDatepicker,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import _ from "lodash";

export default {
  data() {
    return {
      search: {
        search_data: "",
        status: "",
        paginate: 10,
        page: 1,
        status: "",
        from_date: "",
        to_date: "",
        from_deadline: "",
        to_deadline: "",
      },
      perPageOptions: [10, 25, 50, 100],
      job_opportunities: [],
      permission: {
        edit: false,
        delete: false,
      },
      Status: [
        { id: 1, name: "Active" },
        { id: 2, name: "Inactive" },
      ],
    };
  },
  mounted() {
    this.getResults();
    this.Permission();
  },
  methods: {
    getResults(page) {
      this.search.page = page == null ? this.search.page : page;
      const queryParams = this.buildQueryParamString(this.search);
      axios
        .get(`/app/job/opportunitie/${queryParams}`)
        .then((res) => {
          this.job_opportunities = res.data;
        })
        .catch((e) => {
          this.e(e.response.data.message);
        });
    },

    async Delete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't to delete it!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete("/app/job/opportunitie/" + id)
            .then((response) => {
              this.s(response.data.message);
              this.getResults();
            })
            .catch((e) => {
              this.e(e.data.error);
            });
        }
      });
    },

    SearchData: _.debounce(function () {
      this.search.page = 1;
      this.getResults();
    }, 1000),

    // Paginate Data Gate
    paginateChange() {
      this.search.page = 1;
      this.getResults();
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "job.opportunitie.access") {
          this.permission.access = true;
        }

        if (permission.slug == "job.opportunitie.edit") {
          this.permission.edit = true;
        }

        if (permission.slug == "job.opportunitie.destroy") {
          this.permission.delete = true;
        }
      });
    },
  },
  components: {
    vSelect,
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
    BFormDatepicker,
  },
  watch: {
    "search.search_data": function (val) {
      this.SearchData();
    },
    "search.paginate": function (val) {
      this.paginateChange();
    },
    "search.status": function (val) {
      this.SearchData();
    },
    "search.from_date": function (val) {
      this.SearchData();
    },
    "search.to_date": function (val) {
      this.SearchData();
    },
    "search.from_deadline": function (val) {
      this.SearchData();
    },
    "search.to_deadline": function (val) {
      this.SearchData();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
